import { createStandaloneToast } from "@chakra-ui/react";
import { GetHttpClient } from "./HttpClient";
const { toast } = createStandaloneToast();
const ARABIC_REGEX = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;

class ChatHelper {
  static IsArabic(text = "") {
    if (!text) return false;
    return ARABIC_REGEX.test(text);
  }
  static GetStorage(key) {
    try {
      const ls = JSON.parse(localStorage.getItem("browserData")) || {};
      return ls[key];
    } catch {
      return null;
    }
  }
  static SetStorage(key, value) {
    if (!key) return;
    try {
      const ls = JSON.parse(localStorage.getItem("browserData")) || {};
      if (value === undefined) {
        delete ls[key];
      } else {
        ls[key] = value;
      }
      localStorage.setItem("browserData", JSON.stringify(ls));
    } catch {
      // ignore storage failures
    }
  }
  static ClearStorage(key = null) {
    try {
      if (!key) {
        localStorage.removeItem("browserData");
        return;
      }
      const ls = JSON.parse(localStorage.getItem("browserData")) || {};
      if (key in ls) {
        delete ls[key];
        localStorage.setItem("browserData", JSON.stringify(ls));
      }
    } catch {
      // ignore storage failures
    }
  }
  static Notify(type, message, component = null) {
    const lang = ChatHelper.GetStorage("Lang");
    const rtl = lang === "ar";
    if (component) {
      toast({
        position: rtl ? "top-right" : "top-left",
        status: type === "warn" ? "warning" : type,
        duration: 5000,
        isClosable: true,
        render: () => component,
      });
      return;
    }
    toast({
      position: rtl ? "top-right" : "top-left",
      description: message,
      status: type === "warn" ? "warning" : type,
      duration: 2000,
      isClosable: true,
    });
  }
  static ValidateErrorMessage(error) {
    if (error?.status === "FETCH_ERROR") {
      return "Failed To Fetch Please Contact Admin With Code : 199406";
    }
    if (error?.name === "TypeError") {
      return "Failed To Fetch Please Contact Admin With Code : 199407";
    }
    return (
      error?.data?.message ||
      error?.message ||
      "Failed To Fetch Please Contact Admin With Code : 199408"
    );
  }
  static HandleError(isError, error, options = {}) {
    if (!isError || !error) return;
    if ([401].includes(error?.status)) return;
    const message = this.ValidateErrorMessage(error);
    this.Notify("error", message);
    const {
      HasRedirect = false,
      RedirectPath = "/",
      RedirectStatus = [],
      Navigate = null,
    } = options;
    if (!HasRedirect) return;
    if (
      Array.isArray(RedirectStatus) &&
      RedirectStatus.includes(error?.status)
    ) {
      if (typeof Navigate === "function") {
        Navigate(RedirectPath);
      }
    }
  }
  static CreateProgressBar() {
    let Id = Date.now().toString();
    const ProgressBar = document.createElement("div");
    ProgressBar.style.position = "fixed";
    ProgressBar.style.top = "0.625rem";
    ProgressBar.style.left = "50%";
    ProgressBar.style.transform = "translateX(-50%)";
    ProgressBar.style.width = "18.75rem";
    ProgressBar.style.height = "0.625rem";
    ProgressBar.style.background = "var(--InputBg)";
    ProgressBar.style.borderRadius = "5px";
    ProgressBar.style.zIndex = "9999";
    ProgressBar.innerHTML = `<div id="${Id}" style="height:0.625rem;width:0;background:var(--Spinner);border-radius:5px;transition:width .2s; z-index:9999999;"></div>`;
    document.body.appendChild(ProgressBar);
    const Progress = document.getElementById(Id);
    return { Progress, ProgressBar, Id };
  }
  static ExtractFileNameFromDisposition(disposition) {
    if (!disposition) return `file_${Date.now()}`;
    const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match && utf8Match[1]) {
      return decodeURIComponent(utf8Match[1]);
    }
    const fileNameMatch = disposition.match(/filename=("([^"]+)"|([^;]+))/i);
    if (fileNameMatch) {
      return fileNameMatch[2] || fileNameMatch[3];
    }
    return `file_${Date.now()}`;
  }
  static async DownloadFileFromLink(
    DataUrl,
    FileName,
    { RemoveType = false, RemoveEmbedded = false, RemoveTimestamp = false } = {
      RemoveType: false,
      RemoveEmbedded: false,
      RemoveTimestamp: false,
    },
  ) {
    const { Progress, ProgressBar } = this.CreateProgressBar();
    try {
      const FetchClient = GetHttpClient();
      const User = localStorage.getItem("User")
        ? JSON.parse(localStorage.getItem("User"))
        : null;
      const Local = localStorage.getItem("lang");
      let validUrl = `${DataUrl}${
        DataUrl?.includes("?") ? "&" : "?"
      }Local=${Local}&X-T=${User?.UserAccessToken}`;
      if (!RemoveType) validUrl += `&Type=Download`;
      if (!RemoveEmbedded) validUrl += `&embedded=true`;
      if (!RemoveTimestamp) validUrl += `&timestamp=${new Date().getTime()}`;
      this.Notify("info", "Downloading...");
      const response = await FetchClient.Get(validUrl);
      if (!response.ok) {
        let errorMessage = "Download failed";
        try {
          const contentType = response.headers.get("content-type") || "";
          if (contentType.includes("application/json")) {
            const errJson = await response.clone().json();
            errorMessage =
              errJson?.message || errJson?.error || JSON.stringify(errJson);
          } else {
            const errText = await response.clone().text();
            if (errText) errorMessage = errText;
          }
        } catch {
          // ignore parsing error
        }
        this.Notify("error", errorMessage);
        ProgressBar.remove();
        return;
      }
      const contentLength = response.headers.get("content-length");
      const total = parseInt(contentLength, 10);
      const reader = response.body.getReader();
      let received = 0;
      let chunks = [];
      let done = false;
      while (!done) {
        const result = await reader.read();
        done = result.done;
        if (done) break;
        chunks.push(result?.value);
        received += result?.value?.length;
        const percent = total ? Math.round((received / total) * 100) : null;
        if (percent) {
          Progress.style.width = `${percent}%`;
        }
      }
      const blob = new Blob(chunks);
      const blobUrl = URL.createObjectURL(blob);
      const disposition = response.headers.get("Content-Disposition");
      const fileName = this.ExtractFileNameFromDisposition(disposition);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = FileName || fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
      this.Notify("success", "Download complete!");
    } catch (error) {
      console.log(error);
      const Msg = this.ValidateErrorMessage(error);
      this.Notify("error", `Download failed! Dua : ${Msg}`);
    }
    Progress.style.width = "100%";
    setTimeout(() => ProgressBar.remove(), 1000);
  }
}

export default ChatHelper;
